<template>
  <div class="container display-flex align-center br1" :style="{ backgroundColor }">
    <div class="image-container display-flex align-center justify-center ml1-5">
      <bh-icon v-if="icon" :icon="title === 'Accuracy' ? primaryModel === 'AI' ? 'ai-badge' : 'wrench' : icon" class="f3 ma1 text-white" />
    </div>
    <div class="display-flex flex-column status-details justify-center w60p">
      <div class="f2 display-flex w100p">
       {{ value }}
      </div>
      <div class="f1-5 f1-2-mb">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bh-status',
  props: {
    backgroundColor: {
      type: String
    },
    value: {
      type: [String, Number]
    },
    title: {
      type: String
    },
    icon: {
      type: String
    },
    primaryModel: {
      type: String
    }
  }
}
</script>

<style scoped>
.container {
  box-shadow: 0px 3px 16px #0A4B6D14;
  opacity: 1;
  margin-bottom: 1rem;
}

.image-container {
  width: 5rem;
  height: 5rem;
  border-radius: 11px;
  background-color: rgba(255, 255, 255, 0.4);
}

.image-bg {
  width: 28px;
  height: 26px;
}

.status-details {
  color: #fff;
  text-align: start;
  margin-left: 3rem;
  height: 8rem;
}
</style>
